
export const common = {
  'call.us': 'Rufen Sie uns an',
  'privacy.policy': 'Datenschutzrichtlinie',
  'select.location': 'Wählen Sie Ihren Standort',
  'location.description': 'Wählen Sie Ihren Standort, um die entsprechende Nummer anzurufen',
  'usa': 'USA',
  'non.usa': 'Nicht-USA Anruf oder WhatsApp',
  'documents.downloads': 'Dokumente und Downloads',
  'item': 'Artikel',
  'value': 'Wert',
  'price': 'Preis',
  'product': 'Produkt',
  'msrp': 'UVP',
};
